const ITEMS = [
  "Lágrimas negras",
  "Sabor a mí",
  "Guantanamera",
  "Historia de un amor",
  "María Cristina",
  "Rayito de luna",
  "Contigo",
  "Si tú me dices ven",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center">
        <span className="px-6 md:px-8 font-serif italic text-2xl md:text-4xl text-cream/70 whitespace-nowrap">{t}</span>
        <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="border-y border-gold/15 bg-coal/60 py-6 overflow-hidden" data-testid="repertoire-marquee">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
